import React, { useState } from 'react';
import axios from 'axios';
import { AdminLayout, TabBar } from '../components/AdminLayout';
import BlogTable from '../components/AdminForms/Blog/BlogTable';
import BlogCreateForm from '../components/AdminForms/Blog/BlogCreateForm';
import BlogEditForm from '../components/AdminForms/Blog/BlogEditForm';
import { BlogEntryDTO } from '../DTO/BlogEntryDTO';

const ManageBlogEntries: React.FC = () => {
    const [tab, setTab]                 = useState<'list' | 'create'>('list');
    const [reloadKey, setReloadKey]     = useState(0);
    const [editingEntry, setEditingEntry] = useState<BlogEntryDTO | null>(null);
    const [loadingEdit, setLoadingEdit] = useState(false);

    const refreshTable = () => setReloadKey(prev => prev + 1);

    const handleCreated = () => {
        refreshTable();
        setTab('list');
    };

    const handleEdit = async (id: number) => {
        setLoadingEdit(true);
        try {
            const { data } = await axios.get<BlogEntryDTO>(`/api/blog/${id}`);
            setEditingEntry(data);
        } catch (err) {
            console.error('Failed to load blog entry:', err);
        } finally {
            setLoadingEdit(false);
        }
    };

    return (
        <AdminLayout title="Blog Posts">
            <TabBar
                tabs={[
                    { key: 'list',   label: 'All Posts' },
                    { key: 'create', label: '+ New Post' },
                ]}
                active={tab}
                onChange={(k) => setTab(k as 'list' | 'create')}
            />

            {tab === 'list' ? (
                <>
                    {loadingEdit && (
                        <p className="text-text-secondary mb-4">Loading entry…</p>
                    )}
                    <BlogTable
                        key={reloadKey}
                        onEdit={(entry) => handleEdit(entry.id)}
                    />
                </>
            ) : (
                <BlogCreateForm onCreated={handleCreated} />
            )}

            {editingEntry && (
                <BlogEditForm
                    entry={editingEntry}
                    onUpdated={() => { refreshTable(); setEditingEntry(null); }}
                    onClose={() => setEditingEntry(null)}
                />
            )}
        </AdminLayout>
    );
};

export default ManageBlogEntries;
